import React, { useContext } from "react";
import { DocumentPDF } from "./DocumentPDF";
import { PageWidthContext } from "../dealsPageLayout/DealsPageLayout";

type SignaturePagePDFProps = {
  buffer: Buffer;
};
export const DealSignaturePagePDF = (props: SignaturePagePDFProps) => {
  const { buffer } = props;

  const pageWidth = useContext(PageWidthContext);

  return (
    <div data-testid="signature-page-container">
      <DocumentPDF width={pageWidth} contents={buffer} />
    </div>
  );
};
